export const SPACE = /\s/g

export const CAPTURE_THREE = /(.{3})/g

export const NOT_NUMBER = /[^\d]/g

export const THREE_FOUR_SET_NUMBER = /^(\d{3})(\d{4})$/

export const FIVE_FOUR_SET_NUMBER = /^(\d{5})(\d{4})$/
